import { render, staticRenderFns } from "./PhotoSideBarTabTrackItem.vue?vue&type=template&id=5e768f6d&scoped=true"
import script from "./PhotoSideBarTabTrackItem.vue?vue&type=script&lang=js"
export * from "./PhotoSideBarTabTrackItem.vue?vue&type=script&lang=js"
import style0 from "./PhotoSideBarTabTrackItem.vue?vue&type=style&index=0&id=5e768f6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e768f6d",
  null
  
)

export default component.exports